import React from 'react';
import '../styles/AzulejoPanel.css';

type TilePattern =
  | 'quatrefoil'
  | 'crossquare'
  | 'leaf'
  | 'compass'
  | 'dotcorners'
  | 'cushion';

const PATTERNS: Record<TilePattern, React.ReactElement> = {
  quatrefoil: (
    <>
      <path
        d="M50 8 C58 30,70 42,92 50 C70 58,58 70,50 92 C42 70,30 58,8 50 C30 42,42 30,50 8Z"
        fill="none"
        stroke="#f3ead8"
        strokeWidth="1.2"
      />
      <circle cx="50" cy="50" r="8" fill="none" stroke="#c25a3a" strokeWidth="1.2" />
      <circle cx="50" cy="50" r="2" fill="#c25a3a" />
    </>
  ),
  crossquare: (
    <>
      <path d="M10 10 L90 10 L90 90 L10 90 Z" fill="none" stroke="#f3ead8" strokeWidth="1" />
      <path d="M10 10 L90 90 M90 10 L10 90" stroke="#f3ead8" strokeWidth="1" />
      <circle cx="50" cy="50" r="14" fill="none" stroke="#c25a3a" strokeWidth="1.2" />
      <circle cx="50" cy="50" r="4" fill="#c25a3a" />
    </>
  ),
  leaf: (
    <g stroke="#f3ead8" strokeWidth="1.2" fill="none">
      <path d="M50 12 Q70 50 50 88 Q30 50 50 12" />
      <path d="M12 50 Q50 70 88 50 Q50 30 12 50" />
      <circle cx="50" cy="50" r="3" fill="#c25a3a" />
    </g>
  ),
  compass: (
    <>
      <g stroke="#f3ead8" strokeWidth="1.1" fill="none">
        <circle cx="50" cy="50" r="34" />
        <circle cx="50" cy="50" r="20" />
        <path d="M50 16 L50 84 M16 50 L84 50" />
      </g>
      <circle cx="50" cy="50" r="5" fill="#c25a3a" />
    </>
  ),
  dotcorners: (
    <>
      <path
        d="M50 8 C58 30,70 42,92 50 C70 58,58 70,50 92 C42 70,30 58,8 50 C30 42,42 30,50 8Z"
        fill="none"
        stroke="#f3ead8"
        strokeWidth="1.2"
      />
      <g fill="#c25a3a">
        <circle cx="30" cy="30" r="2" />
        <circle cx="70" cy="30" r="2" />
        <circle cx="30" cy="70" r="2" />
        <circle cx="70" cy="70" r="2" />
      </g>
    </>
  ),
  cushion: (
    <>
      <g stroke="#f3ead8" strokeWidth="1.2" fill="none">
        <path d="M20 20 Q50 0 80 20 Q100 50 80 80 Q50 100 20 80 Q0 50 20 20Z" />
      </g>
      <circle cx="50" cy="50" r="8" fill="none" stroke="#c25a3a" strokeWidth="1.2" />
    </>
  ),
};

const DEFAULT_TILES: TilePattern[] = [
  'quatrefoil', 'crossquare', 'leaf',
  'compass', 'dotcorners', 'cushion',
  'crossquare', 'quatrefoil', 'compass',
  'leaf', 'cushion', 'dotcorners',
];

const Tile: React.FC<{ pattern: TilePattern }> = ({ pattern }) => (
  <svg viewBox="0 0 100 100">
    <rect width="100" height="100" fill="#0f2a4a" />
    {PATTERNS[pattern]}
  </svg>
);

interface AzulejoPanelProps {
  tiles?: TilePattern[];
  stamp?: string | null;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const AzulejoPanel: React.FC<AzulejoPanelProps> = ({
  tiles = DEFAULT_TILES,
  stamp = 'Silvalde · Azulejo nº 117',
  children,
  className = '',
  style,
}) => (
  <div className={`azulejo ${className}`} style={style}>
    <div className="azulejo-grid" aria-hidden="true">
      {tiles.slice(0, 12).map((p, i) => (
        <Tile key={i} pattern={p} />
      ))}
    </div>
    {stamp && <div className="azulejo-stamp">{stamp}</div>}
    {children}
  </div>
);

export default AzulejoPanel;
export type { TilePattern };
